import Skeleton from "react-loading-skeleton";

import Box from "ds/components/Box";

const RuntimeSecuritySkeleton = () => (
  <Box gap="x-large" direction="column">
    <Skeleton height={164} width={215} borderRadius={12} />
    <Skeleton height={164} width={215} borderRadius={12} />
  </Box>
);

export default RuntimeSecuritySkeleton;
